const WS_STATUS = {
    MESSAGE_TRANSFER: 1,
    REQUEST_TO_SEND_PUBLIC_KEY: 2,
    ACCEPTED_REQUEST_FOR_PUBLIC_KEY: 3,
    REQUEST_TO_DELETE_PUBLIC_KEY: 4
};

export default WS_STATUS;
